import React from "react";
import Clients from "../components/Clients";
import Cta from "../components/Cta";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import Portfolio from "../components/Portfolio";
import Services from "../components/Services";
import { Helmet } from "react-helmet-async";
import img from "../images/Web-developer.svg";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>TeqnoDux | Global Leaders in Software Development</title>
        <meta
          name="description"
          content="TeqnoDux is a global leader in software development, delivering high-quality, custom software solutions tailored to your needs. Explore our innovative services!"
        />
        <meta
          property="og:title"
          content="TeqnoDux | Global Leaders in Software Development"
        />
        <meta
          property="og:description"
          content="TeqnoDux specializes in innovative software development craftsmanship, delivering tailored solutions to empower your business."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="teqnoduxlogo.jpg" />
        <meta property="og:url" content="https://teqnodux.com" />
        <meta property="og:site_name" content="TeqnoDux" />
        <link rel="canonical" href="https://teqnodux.com" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "TeqnoDux",
            description:
              "TeqnoDux is a global leader in software development, delivering high-quality, custom software solutions tailored to your needs. Explore our innovative services!",
            provider: {
              "@type": "Organization",
              name: "TeqnoDux",
              url: "https://teqnodux.com",
            },
            serviceType: [
              "Web Development",
              "Mobile App Development",
              "CRM Consulting",
              "3D Web Solutions",
            ],
            areaServed: "Worldwide",
            image: img,
            url: "https://teqnodux.com/",
          })}
        </script>
      </Helmet>
      <Hero />
      <Intro />
      <Services />
      {/* <Portfolio /> */}
      {/* <Clients /> */}
      <Cta />
      <Footer />
    </>
  );
};

export default Home;
